import { ApprovalStatus, PRStatus, PaymentStatus } from "src/enums/enums";

import { Input, FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";

export const IssuesSelector = ({
  name,
  label,
  value,
  onChange,
  control,
  required = false,
  className = "",
  style = {},
}) => {
  const options = [
    { value: "", label: "Select Issues" },
    { value: "Yearly", label: "Yearly" },
    { value: "Halfyearly", label: "Halfyearly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Bimonthly", label: "Bimonthly" },
    { value: "Monthly", label: "Monthly" },
  ];

  return (
    <FormGroup className={className}>
      {label && <Label for={name}>{label}</Label>}

      {control ? (
        <Controller
          name={name}
          control={control}
          rules={required ? { required: `${label} is required` } : {}}
          render={({ field }) => (
            <Input {...field} type="select" id={name} style={style}>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Input>
          )}
        />
      ) : (
        <Input
          type="select"
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          style={style}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
      )}
    </FormGroup>
  );
};

export const getApprovalStatusPill = (status: ApprovalStatus) => {
  if (status == ApprovalStatus.APPROVED)
    return <span className="badge badge-success">Approved</span>;
  else if (status == ApprovalStatus.REJECTED)
    return <span className="badge badge-danger">Rejected</span>;
  else if (status == "pending")
    return <span className="badge badge-warning">Pending</span>;
  else return <span className="badge badge-secondary">Unknown</span>;
};

export const getPRStatusPill = (status: PRStatus) => {
  if (status == PRStatus.ACCEPT)
    return <span className="badge badge-success">Accepted</span>;
  else if (status == PRStatus.REJECT)
    return <span className="badge badge-danger">Rejected</span>;
  else if (status == "pending")
    return <span className="badge badge-warning">Pending</span>;
  else if (status == "proceed_payment")
    return <span className="badge badge-secondary">Proceed Payment</span>;
  else if (status == "published")
    return <span className="badge badge-primary">Published</span>;
  else return <span className="badge badge-secondary">Unknown</span>;
};

export const getPaymentStatusPill = (status: PaymentStatus) => {
  if (status == PaymentStatus.COMPLETE)
    return <span className="badge badge-success">Complete</span>;
  else if (status == PaymentStatus.FAILED)
    return <span className="badge badge-danger">Failed</span>;
  else if (status == PaymentStatus.NONE)
    return <span className="badge badge-warning">None</span>;
  else if (status == PaymentStatus.PENDING)
    return <span className="badge badge-warning">Pending</span>;
  else return <span className="badge badge-secondary">Unknown</span>;
};
